import { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { sortAlphaNumeric } from 'filter'

import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import Typography from '@mui/material/Typography'
import FormControlLabel from '@mui/material/FormControlLabel'
import Button from '@mui/material/Button'
import { useTheme } from '@mui/material/styles'

const Columns = ({ config, columns, onToggleColumn, onSelectAllColumns }) => {
  const theme = useTheme()
  const isSelectedAll = Object.entries(columns)
    .filter(([key, value]) => !value && config.headers.map(x => x.key).includes(key)).length === 0

  const [selectAll, setSelectAll] = useState(isSelectedAll || false)

  const onToggle = (column) => () =>
    onToggleColumn(column)

  const list = useMemo(() => {
    return [...config.model].sort((left, right) =>
      sortAlphaNumeric(
        left.label,
        right.label,
      ))
  }, [config.model])

  const onSelectAll = () => {
    setSelectAll(!selectAll)
    onSelectAllColumns(!selectAll)
  }

  const isDriverPage = window.location.pathname.includes('/drivers')
  const isFbtPages = window.location.pathname.includes('/fbt')

  return (
    <>
      <Box
        sx={{
          position: 'relative',
          padding: theme.spacing(3),
          background: theme.palette.background.block,
        }}>
        <Box
          sx={{
            display: { xs: 'block', sm: 'flex' },
            justifyContent: { xs: 'flex-start', sm: 'space-between' } ,
          }}>
          <Box>
            <Typography
              color="inherit"
              variant="h5"
              sx={{
                paddingBottom: theme.spacing(1),
              }}>
              Columns
            </Typography>

            <Typography
              variant="body2">
              Select the columns to show and hide relevant information.
            </Typography>
          </Box>

          <Button
            id={selectAll ? 'unselect-btn' : 'select-btn'}
            variant="contained"
            onClick={() => onSelectAll()}
            sx={{
              whiteSpace: 'nowrap',
              marginTop: { xs: theme.spacing(1), sm: 0 },
              width: { xs: '100%', sm: 'auto' }
            }}>
            {selectAll ? 'Unselect All' : 'Select All'}
          </Button>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            paddingTop: theme.spacing(1),
          }}>
          {list.map((node) => {

            // hide id, checkbox and invalid columns

            // ! ! ! DEV NOTE ! ! !
            // this also needs to be edited in page-list-table-header.js

            if (node.key === 'id' || node.key === 'checkbox' || !node.column || node.label === ''
              // hide agreementNo column only on driver report page
              || (isDriverPage && node.key === 'agreementNo')
              // hide accountName column heading on fbt report pages
              || (isFbtPages && node.key === 'accountName')
            ) {
              return null
            }
            return (
              <Box
                key={node.key}
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  width: 160,
                }}>
                <FormControlLabel
                  sx={{
                    userSelect: 'none'
                  }}
                  control={
                    <Checkbox
                      checked={columns[node.key]}
                      color="default"
                      onChange={onToggle(node.key)}
                      value={columns[node.key]}/>
                  }
                  label={node.label} />
              </Box>
            )
          })}
        </Box>
      </Box>
    </>
  )
}

Columns.propTypes = {
  config: PropTypes.object.isRequired,
  columns: PropTypes.object.isRequired,
  onToggleColumn: PropTypes.func.isRequired,
  onSelectAllColumns: PropTypes.func.isRequired,
}

export default Columns
